import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Container,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { requestGetAll } from "../API/request_server";
import Heading from "../components/Heading";

const Team = () => {
  const [_teams, _setTeams] = useState([]);

  const getTeams = async () => {
    try {
      const result = await requestGetAll("teams/getAll");
      _setTeams(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTeams();
  }, []);

  return (
    <Box sx={{ py: 1 }}>
      <Container maxWidth="lg">
        <Heading _title="Our Team" />

        <Grid container spacing={4}>
          {_teams.map((item) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={item.team_id}>
              <Card
                sx={{
                  borderRadius: "24px",
                  textAlign: "center",
                  p: 3,
                  height: "100%",
                  transition: "0.3s",
                  boxShadow: "0 8px 40px rgba(0,0,0,0.08)",
                  "&:hover": {
                    transform: "translateY(-8px)",
                  },
                }}
              >
                <Avatar
                  //src={`http://localhost/backend_ptp_admin/${item.image}`}
                  src={`http://ptp.gkp.pk/backend_ptp_admin/${item.image}`}
                  alt={item.team_title}
                  sx={{
                    width: 120,
                    height: 120,
                    margin: "0 auto",
                    mb: 2,
                    border: "4px solid #1976d2",
                  }}
                />

                <CardContent>
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    {item.team_title}
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    color="primary"
                    fontWeight="600"
                    mb={2}
                  >
                    {item.designation_title}
                  </Typography>

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                    mb={1}
                  >
                    <EmailIcon fontSize="small" color="action" />
                    <Typography variant="body2">{item.email}</Typography>
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                  >
                    <PhoneIcon fontSize="small" color="action" />
                    <Typography variant="body2">{item.contact}</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Team;
